module.exports = __webpack_public_path__ + "img/pro-5-gen-portrait.068e54d.png";